import React from "react";

export default props => (
  <div style={{ marginTop: "60px" }}>{props.children}</div>
);



// WEBPACK FOOTER //
// ./src/components/Page.js